import doc                    from '@widesk-core/decorators/doc';
import model                  from '@widesk-core/decorators/model';
import ShopServiceModel       from '@/models/ShopServiceModel';
import TimestampAble          from '@widesk-core/models/traits/TimestampAble';
import Blamable               from '@/models/traits/Blamable';
import Translatable           from '@widesk-core/models/traits/Translatable';
import { RenderNameProps }    from '@widesk-ui/mixins/ApiModelRenderName';
import ParentTaxonomyModel    from '@models/shop/ParentTaxonomyModel';
import { computed }           from 'mobx';
import ShopEntertainmentModel from '@models/shop/EntertainmentModel';
import WithEntertainmentPath  from '@/models/mixins/withEntetainmentPath';

const customDoc = doc;

export const FORMATS = {
	list: { key: 'list', label: 'Liste' },
	mosaic: { key: 'mosaic', label: 'Mosaïque' },
};

@model.urnResource('taxonomy')
@doc.path('/taxonomies/{?id}')
export default class TaxonomyModel extends Blamable(TimestampAble(WithEntertainmentPath(Translatable(ShopServiceModel, {
	'label': true,
	'description': true,
})))) {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'enabled': boolean;
		'exists[parent]': boolean;
		'parent': id;
		'slug': id;
		'entertainment': id;
		'entertainment.entertainmentUrn': Urn;
		'translations.label': string;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'position': string;
		'translations.label': string;
		'updatedAt': string;
	};

	@doc.boolean declare enabled: boolean;
	@doc.number declare position: number;
	@doc.string declare slug: string;
	@doc.model(ShopEntertainmentModel) declare entertainment: ShopEntertainmentModel;

	@customDoc.model(ParentTaxonomyModel) declare parent: ParentTaxonomyModel;
	@customDoc.string declare defaultDisplayMode: keyof typeof FORMATS;

	static get prefix() {
		return '/categories/';
	}

	public renderName(props?: RenderNameProps<this> & TaxonomyNameProps) {
		return super.renderName(props);
	}

	@computed get defaultDisplayModeLabel() {
		return FORMATS[this.defaultDisplayMode].label;
	}

	@computed get nextDefaultDisplayModeKey() {
		return this.defaultDisplayMode === 'list' ? 'mosaic' : 'list';
	}

	@computed get nextDefaultDisplayModeLabel() {
		return FORMATS[this.nextDefaultDisplayModeKey].label;
	}

	@computed get parentUrn() {
		return this.parent.urn;
	}
}